import { ContextualMenuItemType, IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';

const styles = require('../components/AttachButtonMenuItem.scss');

export function createReplyWithContextualMenuItemSeparator(): IContextualMenuItem {
    return {
        key: 'replyWithSeparator',
        iconProps: {
            iconName: null,
            styles: {
                root: {
                    margin: '0px',
                    width: '0px',
                },
            },
        },
        className: styles.replyWithSeparator,
        itemType: ContextualMenuItemType.Divider,
    };
}
